<template>
    <div id="view"></div>
</template>

<script>
/* eslint-disable */
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/idea.css'
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import DiffMatchPatch from 'diff-match-patch'
window.diff_match_patch = DiffMatchPatch
window.DIFF_DELETE = -1
window.DIFF_INSERT = 1
window.DIFF_EQUAL = 0

export default {
    name: 'differ',
    props: ['value', 'previous'],
    mounted () {
        let target = document.getElementById('view')
        target.innerHTML = ''
        CodeMirror.MergeView(target, {
            value: this.value || '',
            origLeft: this.previous || '',
            // orig: this.value || '',
            theme: 'idea',
            lineNumbers: true,
            mode: 'application/json',
            highlightDifferences: true,
            connect: 'align',
            revertButtons: false,
            readOnly: true
        })
    }
}
</script>

<style scoped>
.json-editor{
  height: 100%;
  position: relative;
}
.json-editor >>> .CodeMirror {
  height: auto;
  min-height: 300px;
}
.json-editor >>> .CodeMirror-scroll{
  min-height: 300px;
  max-height: 700px;
}
.json-editor >>> .cm-s-idea span.cm-string {
  color: rgb(68, 68, 68);
}
.json-editor >>> .cm-s-idea span.cm-keyword {
  color: rgb(255, 0, 0);
}
</style>
